import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Plus, X, MapPin, Phone, Zap, Trash2, Calendar, Pencil } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const COULEUR_ETAPE = {
  planifie: '#9CA3AF', arrivee: '#3B82F6', previsite: '#6366F1',
  installation: '#F59E0B', codes_barres: '#F59E0B', config_app: '#8B5CF6',
  photos_apres: '#06B6D4', documents: '#14B8A6', termine: '#10B981'
};

const OpsChantiers = () => {
  const [chantiers, setChantiers] = useState([]);
  const [aPlanifier, setAPlanifier] = useState([]);
  const [equipes, setEquipes] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [formOuvert, setFormOuvert] = useState(false);
  const [enEdition, setEnEdition] = useState(null);
  const [erreur, setErreur] = useState('');
  const [form, setForm] = useState({
    prospect_id: '', equipe_id: '', date_prevue: '', creneau: 'journee', duree_jours: 1,
    nb_panneaux: '', puissance_kwc: '', commentaire: ''
  });
  const navigate = useNavigate();

  const charger = async () => {
    try {
      const [rC, rP, rE] = await Promise.all([
        axios.get(`${API}/api/chantiers`),
        axios.get(`${API}/api/chantiers/a-planifier`),
        axios.get(`${API}/api/equipes`)
      ]);
      setChantiers(rC.data.data || []);
      setAPlanifier(rP.data.data || []);
      setEquipes(rE.data.data || []);
    } catch (e) {
      setErreur('Impossible de charger les chantiers');
    } finally {
      setChargement(false);
    }
  };

  useEffect(() => { charger(); }, []);

  const fermer = () => {
    setFormOuvert(false);
    setEnEdition(null);
    setErreur('');
    setForm({ prospect_id: '', equipe_id: '', date_prevue: '', creneau: 'journee', duree_jours: 1, nb_panneaux: '', puissance_kwc: '', commentaire: '' });
  };

  const ouvrirEdition = (c) => {
    setErreur('');
    setEnEdition(c.id);
    setForm({
      prospect_id: c.prospect_id, equipe_id: c.equipe_id || '',
      date_prevue: c.date_prevue || '', creneau: c.creneau || 'journee', duree_jours: c.duree_jours || 1,
      nb_panneaux: c.nb_panneaux ?? '', puissance_kwc: c.puissance_kwc ?? '',
      commentaire: c.commentaire || ''
    });
    setFormOuvert(true);
  };

  const enregistrer = async () => {
    setErreur('');
    if (!form.prospect_id) { setErreur('Sélectionnez un client'); return; }
    if (!form.date_prevue) { setErreur('La date est obligatoire'); return; }
    if (!form.equipe_id) { setErreur('Sélectionnez une équipe'); return; }
    const payload = {
      ...form,
      duree_jours: Number(form.duree_jours) || 1,
      nb_panneaux: form.nb_panneaux === '' ? null : Number(form.nb_panneaux),
      puissance_kwc: form.puissance_kwc === '' ? null : Number(form.puissance_kwc)
    };
    try {
      if (enEdition) {
        delete payload.prospect_id;
        await axios.put(`${API}/api/chantiers/${enEdition}`, payload);
      } else {
        await axios.post(`${API}/api/chantiers`, payload);
      }
      fermer();
      charger();
    } catch (e) {
      setErreur(e.response?.data?.detail || "Erreur lors de l'enregistrement");
    }
  };

  const supprimer = async () => {
    try {
      await axios.delete(`${API}/api/chantiers/${enEdition}`);
      fermer();
      charger();
    } catch (e) {
      setErreur(e.response?.data?.detail || 'Erreur');
    }
  };

  const champ = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', marginBottom: '12px' };

  return (
    <div style={{ padding: '8px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <span style={{ fontSize: '14px', color: '#6B7280' }}>
          {aPlanifier.length > 0 ? `${aPlanifier.length} devis signé(s) à planifier` : 'Aucun devis en attente'}
        </span>
        <button onClick={() => { setErreur(''); setFormOuvert(true); }}
          style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#10B981', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', cursor: 'pointer' }}>
          <Plus size={16} /> Nouveau chantier
        </button>
      </div>

      {erreur && !formOuvert && (
        <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '12px', borderRadius: '8px', marginBottom: '16px' }}>{erreur}</div>
      )}

      {chargement ? (
        <div style={{ background: '#fff', borderRadius: '12px', padding: '32px', textAlign: 'center', color: '#6B7280' }}>Chargement…</div>
      ) : chantiers.length === 0 ? (
        <div style={{ background: '#fff', borderRadius: '12px', padding: '32px', textAlign: 'center', color: '#6B7280' }}>Aucun chantier planifié</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '16px' }}>
          {chantiers.map((c) => (
            <div key={c.id} onClick={() => navigate(`/prospects-entrants/${c.prospect_id}/fiche-rdv`)}
              style={{ background: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', cursor: 'pointer', position: 'relative' }}>

              <button onClick={(ev) => { ev.stopPropagation(); ouvrirEdition(c); }}
                title="Modifier le chantier"
                style={{ position: 'absolute', top: '14px', right: '14px', width: '30px', height: '30px', borderRadius: '8px', border: '1px solid #E5E7EB', background: '#fff', color: '#6B7280', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}>
                <Pencil size={14} />
              </button>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px', paddingRight: '38px' }}>
                <div style={{ fontSize: '16px', fontWeight: 600 }}>
                  {c.client ? `${c.client.prenom} ${c.client.nom}` : 'Client inconnu'}
                </div>
                <span style={{ fontSize: '11px', background: (COULEUR_ETAPE[c.etape] || '#9CA3AF') + '22', color: COULEUR_ETAPE[c.etape] || '#9CA3AF', padding: '3px 10px', borderRadius: '999px', whiteSpace: 'nowrap' }}>
                  {c.etape_libelle}
                </span>
              </div>

              <div style={{ height: '6px', background: '#F3F4F6', borderRadius: '999px', marginBottom: '14px', overflow: 'hidden' }}>
                <div style={{ height: '100%', width: `${c.progression}%`, background: COULEUR_ETAPE[c.etape] || '#9CA3AF', transition: 'width .3s' }} />
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', fontSize: '13px', color: '#6B7280' }}>
                <Calendar size={14} /> {c.date_prevue || '—'} {c.creneau && c.creneau !== 'journee' ? `· ${c.creneau === 'matin' ? 'Matin' : 'Après-midi'}` : ''}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', fontSize: '13px', color: '#6B7280' }}>
                <MapPin size={14} /> {c.client ? `${c.client.ville || ''} ${c.client.code_postal || ''}` : '—'}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', fontSize: '13px', color: '#6B7280' }}>
                <Phone size={14} /> {c.client?.telephone || '—'}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#6B7280' }}>
                <Zap size={14} /> {c.puissance_kwc ? `${c.puissance_kwc} kWc` : c.client?.puissance_installation || '—'}
                {c.nb_panneaux ? ` · ${c.nb_panneaux} panneaux` : ''}
              </div>

              <div style={{ marginTop: '14px', paddingTop: '12px', borderTop: '1px solid #F3F4F6', fontSize: '13px', color: '#374151' }}>
                {c.equipe?.nom || 'Aucune équipe'}
              </div>
            </div>
          ))}
        </div>
      )}

      {formOuvert && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '440px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ margin: 0, fontSize: '18px' }}>{enEdition ? 'Modifier le chantier' : 'Nouveau chantier'}</h3>
              <X size={20} style={{ cursor: 'pointer', color: '#6B7280' }} onClick={fermer} />
            </div>

            {erreur && <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '10px', borderRadius: '8px', marginBottom: '12px', fontSize: '13px' }}>{erreur}</div>}

            {!enEdition && (
              <>
                <label style={{ fontSize: '13px', color: '#6B7280' }}>Client (devis signé) *</label>
                <select style={champ} value={form.prospect_id} onChange={(e) => setForm({ ...form, prospect_id: e.target.value })}>
                  <option value="">Sélectionner…</option>
                  {aPlanifier.map((p) => (
                    <option key={p.id} value={p.id}>{p.prenom} {p.nom} — {p.ville} ({p.code_postal})</option>
                  ))}
                </select>
              </>
            )}

            <label style={{ fontSize: '13px', color: '#6B7280' }}>Équipe *</label>
            <select style={champ} value={form.equipe_id} onChange={(e) => setForm({ ...form, equipe_id: e.target.value })}>
              <option value="">Sélectionner…</option>
              {equipes.map((eq) => <option key={eq.id} value={eq.id}>{eq.nom}</option>)}
            </select>

            <label style={{ fontSize: '13px', color: '#6B7280' }}>Date prévue *</label>
            <input style={champ} type="date" value={form.date_prevue} onChange={(e) => setForm({ ...form, date_prevue: e.target.value })} />

            <label style={{ fontSize: '13px', color: '#6B7280' }}>Durée</label>
            <select style={champ} value={form.duree_jours === 0.5 ? 'demi' : String(form.duree_jours)}
              onChange={(e) => {
                const v = e.target.value;
                if (v === 'demi') setForm({ ...form, duree_jours: 1, creneau: 'matin' });
                else setForm({ ...form, duree_jours: Number(v), creneau: 'journee' });
              }}>
              <option value="demi">Demi-journée</option>
              <option value="1">1 jour</option>
              <option value="2">2 jours</option>
              <option value="3">3 jours</option>
              <option value="4">4 jours</option>
              <option value="5">5 jours</option>
            </select>

            {(form.creneau === 'matin' || form.creneau === 'apres_midi') && (
              <>
                <label style={{ fontSize: '13px', color: '#6B7280' }}>Créneau</label>
                <select style={champ} value={form.creneau} onChange={(e) => setForm({ ...form, creneau: e.target.value })}>
                  <option value="matin">Matin (8h30 - 13h)</option>
                  <option value="apres_midi">Après-midi (14h30 - 19h)</option>
                </select>
              </>
            )}

            <label style={{ fontSize: '13px', color: '#6B7280' }}>Puissance (kWc)</label>
            <input style={champ} type="number" step="0.5" placeholder="ex. 3" value={form.puissance_kwc} onChange={(e) => setForm({ ...form, puissance_kwc: e.target.value })} />

            <label style={{ fontSize: '13px', color: '#6B7280' }}>Nombre de panneaux</label>
            <input style={champ} type="number" placeholder="ex. 6" value={form.nb_panneaux} onChange={(e) => setForm({ ...form, nb_panneaux: e.target.value })} />

            <textarea style={{ ...champ, minHeight: '70px' }} placeholder="Commentaire pour l'équipe" value={form.commentaire} onChange={(e) => setForm({ ...form, commentaire: e.target.value })} />

            <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
              <button onClick={fermer} style={{ flex: 1, padding: '10px', border: '1px solid #D1D5DB', background: '#fff', borderRadius: '8px', cursor: 'pointer' }}>Annuler</button>
              <button onClick={enregistrer} style={{ flex: 1, padding: '10px', border: 'none', background: '#10B981', color: '#fff', borderRadius: '8px', cursor: 'pointer' }}>Enregistrer</button>
            </div>

            {enEdition && (
              <button onClick={supprimer}
                style={{ width: '100%', marginTop: '10px', padding: '9px', border: '1px solid #FCA5A5', background: '#fff', color: '#B91C1C', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontSize: '13px' }}>
                <Trash2 size={14} /> Supprimer le chantier
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OpsChantiers;
